<script lang="ts" setup>
defineProps<{
  title: string
  durationDays?: number | null
  optional?: boolean
}>()

const { t } = useI18n()
</script>

<template>
  <button class="module-card" type="button">
    <span class="module-type text-xsmall f-medium">
      <Icon :name="optional ? 'modules' : 'course'" />
      {{ optional ? t('tocco.eventList.optionalModule') : t('tocco.eventList.requiredModule') }}
    </span>
    <span class="module-title text-small">{{ title }}</span>
    <span v-if="durationDays" class="module-duration text-xsmall f-medium">
      {{ t('tocco.durationDays', durationDays) }}
    </span>
  </button>
</template>

<style lang="scss" scoped>
.module-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  min-height: 207px;
  padding: 24px 32px;

  text-align: left;
  background: var(--c-background-strong);

  @include transitions(background-color, box-shadow);

  @include hover {
    background-color: var(--c-white);
    box-shadow: var(--shadow);

    .module-title {
      color: var(--c-blue-rollover);
    }
  }
}

.module-type {
  display: flex;
  align-items: center;
  gap: 4px;

  padding: 8px 12px;

  color: var(--c-primary);
  border: 1px solid rgba(var(--c-blue-100-rgb), 0.6);
  border-radius: 4px;
}

.module-title {
  color: var(--c-primary);
  font-weight: bold;

  @include transitions(color);
}

.module-duration {
  margin-top: auto;
}
</style>
